// The "Flash firmware" dialog. Logic in flasher.js; this file draws it.
import { BOOTLOADER_FILTERS, flashFirmware, loadImages } from './flasher.js';
import { button, paragraph, openWizardDialog } from './wizard_dialog.js';

// disconnect(): closes the page's own serial connection first.
export function openFlasher({ disconnect }) {
  let busy = false;
  const close = () => {
    if (!busy) dlg.close(); // a running flash must not be interrupted
  };
  const dlg = openWizardDialog({ onRequestClose: close });
  const show = dlg.show;

  const intro = async () => {
    let images = null;
    let problem = null;
    try {
      images = await loadImages();
    } catch (e) {
      problem = e.message;
    }
    const erase = Object.assign(document.createElement('input'), { type: 'checkbox', id: 'flash-erase-settings' });
    const eraseLabel = document.createElement('label');
    eraseLabel.append(erase, ' Also delete my saved pin settings (the Button, LED and Bus pins setup starts from scratch)');
    const start = button('Choose the device and flash', () => run(images, erase.checked));
    start.disabled = !images;
    show(
      'Flash the firmware',
      [
        paragraph(images ? `This writes firmware <strong>${images.version}</strong> to the ESP32. Your saved pin settings are kept unless you tick the box below.` : `<strong>${problem}</strong>`),
        paragraph('<strong>Unplug the serial cable from the C64 first.</strong>'),
        paragraph('<strong>Stay on this tab while flashing.</strong> Browsers slow down background tabs, so flashing stops or crawls when you switch to another tab or minimise the window. It only takes about half a minute.'),
        paragraph('Click the button below and pick the board (“CP210x” or “USB Serial”) in the browser’s list. The board puts itself into its boot loader, there is nothing to press.'),
        eraseLabel,
      ],
      [button('Cancel', close, 'outline secondary'), start],
    );
  };

  const run = async (images, eraseSettings) => {
    let port;
    try {
      port = await navigator.serial.requestPort({ filters: BOOTLOADER_FILTERS });
    } catch {
      return; // the chooser was dismissed
    }
    busy = true;
    await disconnect();
    const bar = Object.assign(document.createElement('progress'), { max: 100, value: 0 });
    const log = document.createElement('small');
    show('Flashing…', [paragraph('Do not unplug anything and <strong>do not switch to another tab</strong> until it is done: a background tab makes flashing very slow.'), bar, log], []);
    try {
      const lib = await import('esptool-js');
      await flashFirmware({
        port,
        lib,
        images,
        eraseSettings,
        onProgress: (f) => (bar.value = Math.round(f * 100)),
        onLog: (s) => (log.textContent = String(s).trim().split('\n').pop()),
      });
      busy = false;
      show(
        'Flashed',
        [paragraph(`The device restarts by itself. Then click <strong>Connect</strong> in the page header and pick the board again.`)],
        [button('Close', close)],
      );
    } catch (e) {
      busy = false;
      show('That did not work', [paragraph(`${e.message}`), paragraph('Check that the right port was picked, that no other program (or tab) has it open, and try again.')], [button('Close', close, 'outline secondary'), button('Try again', intro)]);
    }
  };

  intro();
}
